import { isBefore } from "date-fns";

import { dateDiff, TimeType } from "@/lib/date";
import { zonedDate } from "@/lib/helpers/date";
import { preferencesStorageCache } from "@/lib/storage/preferences-storage-cache";
import type { RootRouteContext } from "@/routes/-root/-root-context";

export const shouldShowGeneralTermsPage = async (
  context: RootRouteContext,
): Promise<boolean> => {
  const generalTermsConfigurations = context.ldClient.getGeneralTermsConfiguration();

  const isGeneralTermsActive = generalTermsConfigurations.exibePagina;

  if (!isGeneralTermsActive) {
    return false;
  }

  const isMemberValidationBeforeLastGeneralTerms = isBefore(
    zonedDate(context.user.dataValidacao ?? new Date()),
    zonedDate(generalTermsConfigurations.dataCorteNovosMembros),
  );

  // TODO: Adicionar validação se o termo assinado é o mais recente

  if (
    !isMemberValidationBeforeLastGeneralTerms ||
    context.user.termoDeUsoAceitoMaisRecente
  ) {
    return false;
  }

  const shouldGoToGeneralTermsPages = await shouldShowGeneralTermsPageTimeBased();

  return shouldGoToGeneralTermsPages;
};

export const shouldShowGeneralTermsPageTimeBased = async (): Promise<boolean> => {
  const pendingTermsOfUseAgreed = "pendingTermsOfUseAgreedNotification";
  const hoursGap = 24;

  const now: Date = zonedDate(new Date());

  const lastNotificationTermsOfUseAgreed = String(
    (await preferencesStorageCache.get(pendingTermsOfUseAgreed)) ?? "",
  );

  if (!lastNotificationTermsOfUseAgreed) {
    await preferencesStorageCache.set(pendingTermsOfUseAgreed, now);

    return true;
  }

  const lastNotification: Date = zonedDate(lastNotificationTermsOfUseAgreed);
  const hoursBetween = dateDiff(lastNotification, now, TimeType.Hours);

  return hoursBetween >= hoursGap;
};
